import { render, staticRenderFns } from "./staSelf.vue?vue&type=template&id=6611db52&scoped=true"
import script from "./staSelf.vue?vue&type=script&lang=js"
export * from "./staSelf.vue?vue&type=script&lang=js"
import style0 from "./staSelf.vue?vue&type=style&index=0&id=6611db52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6611db52",
  null
  
)

export default component.exports